import axiosInstance from './AxiosWrapper'
import { API_URL } from '../utils/constantes'
import {
  ENDPOINT_AUTH_EXCHANGE,
  ENDPOINT_AUTH_LOGIN,
  ENDPOINT_AUTH_LOGOUT,
  ENDPOINT_LOGIN,
  ENDPOINT_USER,
} from './Endpoints'

export const logIn = async (login, password) => {
  return await axiosInstance.post(ENDPOINT_LOGIN, { login, password })
}

export const getUser = async (id) => {
  return await axiosInstance.get(ENDPOINT_USER, { params: { id } })
}

export const getSsoLoginUrl = (redirectPath) => {
  const url = new URL(`${API_URL}${ENDPOINT_AUTH_LOGIN}`)
  if (redirectPath) {
    url.searchParams.set('redirect', redirectPath)
  }
  return url.toString()
}

export const exchangeSsoTicket = async (ticket) => {
  return await axiosInstance.post(ENDPOINT_AUTH_EXCHANGE, { ticket })
}

export const logOutSso = async (refreshToken) => {
  return await axiosInstance.post(ENDPOINT_AUTH_LOGOUT, { refreshToken })
}
